import * as React from "react";

function SvgDot(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12} r={2} fill="currentColor" />
    </svg>
  );
}

const MemoSvgDot = React.memo(SvgDot);
export default MemoSvgDot;
